import React, { useEffect, useState } from "react";
import styled, { keyframes, css } from "styled-components";

const draw = keyframes`
  to { stroke-dashoffset: 0; }
`;

const fadeUp = keyframes`
  0% { opacity: 0; transform: translateY(10px); }
  100% { opacity: 1; transform: translateY(0); }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background-color: ${({ theme }) => theme.bg};
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  overflow: hidden;

  ${(p) =>
    p.$exiting &&
    css`
      animation: curtainUp 0.5s cubic-bezier(0.6, 0, 0.4, 1) forwards;
    `}

  @keyframes curtainUp {
    0% {
      transform: translateY(0);
      filter: brightness(1);
    }
    100% {
      transform: translateY(-100%);
      filter: brightness(1.4);
    }
  }
`;

const Ring = styled.svg`
  width: 96px;
  height: 96px;
  overflow: visible;

  circle {
    fill: none;
    stroke: ${({ theme }) => theme.primary};
    stroke-width: 3.5;
    stroke-linecap: round;
    stroke-dasharray: 300;
    stroke-dashoffset: 300;
    animation: ${draw} 0.6s ease-in-out forwards;
    animation-delay: 0.1s;
  }
`;

const Name = styled.div`
  font-family: "Caveat", cursive;
  font-weight: 700;
  font-size: 2.6rem;
  color: ${({ theme }) => theme.text_primary};
  opacity: 0;
  animation: ${fadeUp} 0.3s ease-out forwards;
  animation-delay: 0.5s;
`;

const Sub = styled.div`
  font-family: "Kalam", cursive;
  font-size: 1rem;
  color: ${({ theme }) => theme.text_secondary};
  opacity: 0;
  animation: ${fadeUp} 0.3s ease-out forwards;
  animation-delay: 0.6s;
`;

const Preloader = () => {
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setExiting(true), 900);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Container $exiting={exiting}>
      <Ring viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="42" />
      </Ring>
      <Name>Hi, I&apos;m Sumedha</Name>
      <Sub>sketching the page...</Sub>
    </Container>
  );
};

export default Preloader;
